import { render } from "./showDetail.vue?vue&type=template&id=d52aed9c&scoped=true"
import script from "./showDetail.vue?vue&type=script&lang=js"
export * from "./showDetail.vue?vue&type=script&lang=js"

import "./showDetail.vue?vue&type=style&index=0&id=d52aed9c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52aed9c"]])

export default __exports__